import CompetitionDetails from "./CompetitionDetails";
import CompetitionsList from "./CompetitionsList";

export default {
    list: CompetitionsList,
    details: CompetitionDetails
}